<template>
  <div>
    <v-form ref="postVentaForm">
      <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Estatus"
            v-model="form.status"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :items="status"
            :readonly="readOnly"
            :rules="required"
            item-text="label"
            item-value="value"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Canal"
            v-model="form.canal"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :items="canaleslist"
            :readonly="readOnly"
            :rules="required"
            item-text="canal"
            item-value="canal"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Ramo"
            v-model="form.ramo"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :items="ramoslist"
            :readonly="readOnly"
            :rules="required"
            item-text="ramo"
            item-value="ramo"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Campaña"
            :rules="required"
            v-model="form.campania"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Empresa"
            v-model="form.empresa"
            :items="empresaslist"
            item-text="empresa"
            item-value="empresa"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :readonly="readOnly"
            :rules="required"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Aseguradora"
            v-model="form.aseguradoraId"
            :items="aseguradorasList"
            item-text="nombre"
            item-value="id"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :readonly="readOnly"
            :rules="required"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Tipificación"
            :rules="required"
            v-model="form.tipificacion"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Motivos"
            :rules="required"
            v-model="form.motivo"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Servicio Ivr"
            :rules="required"
            v-model="form.servicioIvr"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Agente"
            :items="agentesList"
            item-text="nombreCompleto"
            item-value="id"
            v-model="form.agenteId"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :readonly="readOnly"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" m="12" md="6" lg="3" xl="3 ">
          <v-autocomplete
            label="Plantilla Eci"
            outlined
            :items="plantillasECIList"
            item-text="nombre"
            item-value="id"
            v-model="form.plantillasEciId"
            primary
            color="#00a7e4"
            type="text"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" m="12" md="6" lg="3" xl="3 ">
          <v-autocomplete
            label="Cuenta Correo"
            outlined
            :items="correosList"
            item-text="cuenta"
            item-value="id"
            v-model="form.cuentaCorreoId"
            primary
            color="#00a7e4"
            type="text"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" m="12" md="6" lg="3" xl="3 ">
          <v-text-field
            label="Documentos Solicitados"
            outlined
            v-model="form.documentosSolicitados"
            primary
            color="#00a7e4"
            type="text"
          ></v-text-field>
        </v-col>
        <v-col cols="12" m="12" md="6" lg="3" xl="3 ">
          <v-text-field
            label="SLA"
            outlined
            v-model="form.sla"
            primary
            color="#00a7e4"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" m="12" md="6" lg="3" xl="3 ">
          <v-text-field
            label="Toque 1"
            outlined
            v-model="form.toque1"
            primary
            color="#00a7e4"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" m="12" md="6" lg="3" xl="3 ">
          <v-text-field
            label="Toque 2"
            outlined
            v-model="form.toque2"
            primary
            color="#00a7e4"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" m="12" md="6" lg="3" xl="3 ">
          <v-text-field
            label="Toque 3"
            outlined
            v-model="form.toque3"
            primary
            color="#00a7e4"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { getPosVentaDetalles } from "@/services/campañasPostVentaInbound/CampañasPostVentaInbound.js";
import { getCanalList } from "@/services/canal/canal.service.js";
import { getRamoList } from "@/services/ramo/ramo.service.js";
import { getEmpresasInbound } from "@/services/empresasInbound/EmpresasInbound.js";
import { getAgenteById, getAgentesByRolAndCanalId } from "@/services/user/user.service";
import { getPlantillaByDepartamento, getPlantillaById } from "@/services/plantillasECI/plantillaECI.service";
import {getCuentasCorreoByDepartamento} from "@/services/cuentasCorreo/cuentasCorreo.service.js";



import { mainAxios } from "@/mainAxios.js";

export default {
  components: {},
  data: () => {
    return {
      required: [(value) => !!value || "Campo Requerido"],
      form: {
        campania: null,
        aseguradoraId: null,
        ramo: null,
        canal: null,
        empresa: null,
        tipificacion: null,
        motivo: null,
        plantilla: null,
        plantillasEciId: null,
        correoRemitente: null,
        cuentaCorreoId: null,
        servicioIvr: null,
        agenteId: null,
        status: null,
        documentosSolicitados: null,
        sla: null,
        toque1: null,
        toque2: null,
        toque3: null,
      },
      canaleslist: [],
      ramoslist: [],
      plantillasECIList:[],
      campanias: [],
      correosList: [],
      status: [
        { label: "Activo", value: 1 },
        { label: "Inactivo", value: 2 },
        { label: "Baja", value: 3 },
      ],
      empresaslist: [],
      agentesList:[],
      aseguradorasList: [],
    };
  },
  props: {
    toSave: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    cuentaId: {
      type: Number,
      default: null,
    },
  },
  watch: {


    //Ver a donde llama esta función || Llama a una funcion q se encuentra en el padre para editar / crear
    toSave(val) {
      if (val) {
        this.$refs.postVentaForm.validate();
        this.$emit("goTosave", this.$refs.postVentaForm.validate(), this.form);
      }
    },
    cuentaId(newVal) {
      if (newVal) {
        this.getPosVentaDetalles();
      }
    },
    'form.agenteId': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getAgenteById(newVal);
        }
      }
    },
    'postVentaForm.plantillasEciId':{
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getPlantillaECIById(newVal);
        }
      }
    },
  },
  computed: {

  },
  mounted() {
    this.getCanales();
    this.getCanalId();
    this.getRamos();
    this.getAgentesList(); // Obtiene los agentes con rol "AGENT" y canal "2"
    this.getEmpresasInbound();
    this.getAseguradoras();
    this.getPlantillasECI();
    this.getCuentasCorreo();
   
    if (this.cuentaId) {
      this.getPosVentaDetalles(); // Llama a la función si cuentaId ya tiene un valor.
    }
  },
  methods: {
    async getPosVentaDetalles() {
      this.cuentaEditable = await getPosVentaDetalles(this.cuentaId);
      (this.form = {
        campania: this.cuentaEditable.campania,
        aseguradoraId: this.cuentaEditable.aseguradoraId,
        ramo: this.cuentaEditable.ramo ? this.cuentaEditable.ramo : null,
        canal: this.cuentaEditable.canal
          ? this.cuentaEditable.canal
          : null,
        empresa: this.cuentaEditable.empresa,
        tipificacion: this.cuentaEditable.tipificacion,
        motivo: this.cuentaEditable.motivo,
        plantilla: this.cuentaEditable.plantilla,
        plantillasEciId: this.cuentaEditable.plantillasEciId,
        correoRemitente: this.cuentaEditable.correoRemitente,
        servicioIvr: this.cuentaEditable.servicioIvr,
        agenteId: this.cuentaEditable.agenteId,
        status: this.cuentaEditable.status,
        cuentaCorreoId: (this.cuentaEditable.cuenta_correo_id ? this.cuentaEditable.cuenta_correo_id : null),
        documentosSolicitados: (this.cuentaEditable.documentos_solicitados ? this.cuentaEditable.documentos_solicitados : null),
        sla: (this.cuentaEditable.sla ? this.cuentaEditable.sla : null),
        toque1: (this.cuentaEditable.toque_1 ? this.cuentaEditable.toque_1 : null),
        toque2: (this.cuentaEditable.toque_2 ? this.cuentaEditable.toque_2 : null),
        toque3: (this.cuentaEditable.toque_3 ? this.cuentaEditable.toque_3 : null)
      });
       
    },


    async getAgenteById(id) {
          const response = await getAgenteById(id);
          this.agenteNombre = [response.nombre, response.apellidoPaterno, response.apellidoMaterno].filter(Boolean).join(" ") || "No disponible";
    },

    async getCanales() {
      this.canaleslist = await getCanalList();
    },
    async getRamos() {
      this.ramoslist = await getRamoList();
    },

    async getAgentesList(){
        const agentes = await getAgentesByRolAndCanalId("AGENT", 2);
        this.agentesList = agentes.data.agentes;
    },
    getRamoIdbyName(name) { 
      const ramo = this.ramoslist.find((item) => item.ramo === name);
  
      this.cuentaEditable.ramo=  ramo ? ramo.id : null;
    },

    getCanalId(nombrecanal) {
      const idcanal = this.canaleslist.find(
        (item) => item.canal === nombrecanal
      );
      return idcanal ? idcanal.canal : null;
    },
    async getPlantillasECI(){
      const response = await getPlantillaByDepartamento("POST-VENTA");
      this.plantillasECIList = response.data.plantillas;
    },
    async getCuentasCorreo(){
      const response = await getCuentasCorreoByDepartamento("POST-VENTA");
      this.correosList = response.data.correos;
    },


    async getEmpresasInbound() {
      const response = await getEmpresasInbound();
      this.empresaslist = response.data.empresas;
    },

    getAseguradoras() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios.get("/v1/aseguradora/list", config).then((response) => {
        response.data.map((element) => {
          this.aseguradorasList.push({
            nombre: `${element.nombre}`,
            id: element.id,
            uuid: element.uuid,
          });
        });
       
      });
    },
    async getPlantillaECIById(id){
      const response = await getPlantillaById(id);
      this.plantillaECI = response.asunto;
    }
  },
};
</script>

<style scoped>
.v-application p {
  margin-bottom: 0px !important;
}
</style>
